<template>
    <div class="page-title-area bg-2">
        <div class="container">
            <div class="page-title-content">
                <h2>Pricing</h2>
                <ul>
                    <li>
                        <router-link to="/">
                            Home 
                        </router-link>
                    </li>
                    <li class="active">Pricing</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageTitle'
}
</script>